import { css } from "@emotion/react";
import { FontFamily } from "../constants";
export var FontWeight;
(function (FontWeight) {
    FontWeight["Bold"] = "Bold";
    FontWeight["Medium"] = "Medium";
    FontWeight["Regular"] = "Regular";
    FontWeight["Light"] = "Light";
})(FontWeight || (FontWeight = {}));
export const getCSSFontWeight = (weight) => ({
    [FontWeight.Bold]: "bold",
    [FontWeight.Medium]: "500",
    [FontWeight.Regular]: "normal",
    [FontWeight.Light]: "300",
})[weight];
export const TextBaseStyle = css `
  font-family: ${FontFamily};
  margin: 0;
`;
export const TextBase = (fontWeight = FontWeight.Regular) => css `
  font-family: ${FontFamily};
  margin: 0;
  font-weight: ${getCSSFontWeight(fontWeight)};
`;
//# sourceMappingURL=base.js.map